import React from 'react';
import PropTypes from 'prop-types';
import { pureRender } from 'epic-alt-utils/index';

@pureRender
export default class CtaButton extends React.Component {
    static propTypes = {
        cta: PropTypes.object,
        toggleNav: PropTypes.func
    };

    static contextTypes = {
        globalLinkOnClick: PropTypes.func
    };

    onClick = (e) => {
        const cta = this.props.cta || {};
        const href = cta.href || '#';
        let globalReturnValue = null;
        if (this.context.globalLinkOnClick && typeof this.context.globalLinkOnClick === 'function') {
            globalReturnValue = this.context.globalLinkOnClick(e, href);
        }

        if (globalReturnValue !== false) {
            if (cta && cta.onClick && typeof cta.onClick === 'function') {
                cta.onClick(e);
            }
        }
        this.props.toggleNav();
    };

    render() {
        const config = this.props.cta || {};
        const label = config.title || '';
        const href = config.href || '#';
        if (!label) {
            console.warn('[EGH] no cta title was provided. The component will not be rendered');
            return (<div />);
        }

        return (
            <div className="cta accent-bg-color accent-bg-color-hover" id="cta">
                <a href={href} onClick={this.onClick} className="accent-bg-color accent-bg-color-hover" title={label}>
                    <span className="accent-text-color accent-text-color-hover">{label}</span>
                </a>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/scripts/components/ctaButton/CtaButton.js